import React from "react";
import successIcon from "../../../img/successIconSignModal.svg";

const SuccessModal = (props) => {

    const {
        isModalMessage,
        onCloseModal
    } = props;

    return (
            <div className="success-modal__container">
                <div className="success-modal">
                    <div className="success-modal__title">
                        <img src={successIcon} alt={'иконка'}/>
                        <h3>Success!</h3>
                    </div>
                    <div className="success-modal-message">
                        <p className="success-modal-message__text">{isModalMessage}</p>
                    </div>
                    <div className="success-modal__buttons-block">
                        <button onClick={() => onCloseModal()} className="success-modal__button-create" type={"button"}>Ok</button>
                    </div>
                </div>
            </div>
    )
}
export default SuccessModal;